<template>
  <b-col cols="12">
    <GenericTable
      id="tab_ambassades"
      ref="genericTableListeAmbassades"
      :actions="actions"
      :colonnes="cols"
      :endpoint-url="endpoint"
      :filterable-col="filterableCol"
      @action-callback="dispatchAction"
      @row-click="openDetails"
    />
    <AmbassadeModal />
    <ModalExportCommandesFactures />
  </b-col>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import AmbassadeModal from "@/components/ambassades/AmbassadeModal.vue";
import ModalExportCommandesFactures from "@/components/commandes/ModalExportCommandesFactures.vue";

import Api from "@/modules/axios";

export default {
  name: "ListeAmbassades",
  components: {
    GenericTable,
    AmbassadeModal,
    ModalExportCommandesFactures,
  },
  data() {
    return {
      cols: [
        { key: "compte", defaultOrder: true },
        { key: "date_creation", overrideName: "Créée le" },
        { key: "remarques" },
        { key: "ville" },
        { key: "pays" },
        { key: "date_modification", overrideName: "Modifiée le" },
        { key: "user_updated", overrideName: "Modifiée par" },
      ],
      filterableCol: ["compte", "nom", "pays__nom"],
      endpoint: "/ambassade",
    };
  },
  computed: {
    actions() {
      const actions = [
        { title: "Ajouter", callback: "add" },
        // Voir si on garde ou pas
        // { title: "Exporter", callback: "export" },
      ];

      if (
        this.$store.state[this.$route.name]
        && this.$store.state[this.$route.name].displayArchived
      ) {
        actions.push({ title: "Désarchiver", callback: "unarchive" });
      } else {
        actions.push({ title: "Supprimer", callback: "delete" });
      }

      return actions;
    },
  },
  mounted() {
    this.$store.commit(
      `${this.$route.name}/setFormatDataFunction`,
      this.getVerbose,
    );
  },
  methods: {
    /**
     * Affiche la modale de l'ambassade avec ses détails.
     * @public
     * @param {Object} ambassade Ambassade sélectionnée.
     */
    openDetails(ambassade) {
      this.$modal.show("ambassade", {
        ambassade,
      });
    },
    /**
     * Exécute les actions du tableau des ambassades.
     * @public
     * @param {String} actionCode Action sélectionnée.
     */
    dispatchAction(actionCode) {
      // On execute le dispatch générique qui gére le delete
      const resCode = this.$refs.genericTableListeAmbassades.genericDispatch(
        actionCode,
        this.$route.name,
        this.endpoint,
        "une ambassade",
      );

      if (resCode === -1) {
        // const checkedRows = this.$store.getters[
        //   `${this.$route.name}/rowDisplayed`
        // ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "add":
            this.$modal.show("ambassade", { new: true });
            break;

            // Voir si on garde ou pas
            // case "export":
            //   if (checkedRows.length == 1) {
            //     // TODO: export
            //   } else {
            //     displayErrorSelectOne("une ambassade");
            //   }
            //   break;

          default:
            break;
        }
      }
    },
    /**
     * Met en forme les données du tableau des ambassades.
     * @public
     * @param {Object} data Données du tableau.
     * @return {Promise}
     */
    getVerbose(data) {
      const { results } = data;
      // ======== Gestion des pays ==========
      const paysIds = [...new Set(results.map((item) => item.pays))];

      const promise1 = Api()
        .get(`pays/?id__in=${paysIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabPays = res.data.results;
          results.forEach((ligne) => {
            ligne.pays_verbose = (
              tabPays.find((pays) => ligne.pays === pays.id) || {}
            ).nom;
          });
          return res;
        });
      // ======== FIN Gestion des pays ==========

      // ======== Gestion des users ==========
      const usersUpdatedIds = [
        ...new Set(results.map((item) => item.user_updated)),
      ];

      const promise2 = Api()
        .get(`user/?id__in=${usersUpdatedIds.join(",")}&page_size=100`)
        .then((res) => {
          const tabUserUpdated = res.data.results;
          results.forEach((ligne) => {
            ligne.user_updated_verbose = (
              tabUserUpdated.find(
                (userUpdated) => ligne.user_updated === userUpdated.id,
              ) || {}
            ).username;
          });
          return res;
        });
      // ======== FIN Gestion des users ==========

      return Promise.all([promise1, promise2]);
    },
  },
};
</script>

<style lang="scss">
#tab_ambassades {
  .compte { width: 120px; }
  .date_creation { width: 100px; }
  .remarques { min-width: 350px; }
  .ville { width: 250px; }
  .pays { width: 250px; }
  .date_modification { width: 130px; }
  .user_updated { width: 250px; }
}
</style>
